import { env } from 'config';
import { TelegramFlow, PaginatedData, QueryParams } from 'types';
import { apiUtils } from 'utils';

import { createCrudApi } from './crud.api';

const path = '/telegram-flow';
const url = `${env.apiUrl}${path}`;

const getTradersPaginated = async (
  params?: QueryParams,
): Promise<PaginatedData<TelegramFlow>> =>
  (await apiUtils.getWithQueryParams(`${url}/traders/paginated`, params)).data;

const getShopsPaginated = async (
  params?: QueryParams,
): Promise<PaginatedData<TelegramFlow>> =>
  (await apiUtils.getWithQueryParams(`${url}/shops/paginated`, params)).data;

const getP2PProvidersPaginated = async (
  params?: QueryParams,
): Promise<PaginatedData<TelegramFlow>> =>
  (await apiUtils.getWithQueryParams(`${url}/p2p-providers/paginated`, params))
    .data;

export const telegramFlowApi = {
  getTradersPaginated,
  getShopsPaginated,
  getP2PProvidersPaginated,
  ...createCrudApi<TelegramFlow>(path),
};
